if (!customElements.get('slider-products')) {
  class SliderProducts extends HTMLElement {
    constructor() {
      super();

      this.slidesPerGroup = parseInt(this.dataset.slidesPerGroup) || 3;

      this.selectors = {
        slider: '[data-slider]',
      };

      this.settings = {
        elements: {
          slider: this.querySelector(this.selectors.slider),
        },
        instances: {
          slider: null,
        },
        options: {
          slider: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 32,
            loop: true,
            loopAdditionalSlides: this.slidesPerGroup,
            navigation: {
              prevEl: this.querySelector('.swiper-arrow--prev'),
              nextEl: this.querySelector('.swiper-arrow--next'),
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
              },
              990: {
                slidesPerView: 3,
                slidesPerGroup: this.slidesPerGroup,
              }
            }
          },
        },
      };

      if (this.dataset.loop === 'true') {
        this.settings.options.slider.breakpoints[990].loop = true;
        this.settings.options.slider.breakpoints[990].loopAdditionalSlides = this.slidesPerGroup;
      } else {
        this.settings.options.slider.breakpoints[990].loop = false;
        this.settings.options.slider.breakpoints[990].loopAdditionalSlides = 0;
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.settings.instances.slider = new Swiper(
        this.settings.elements.slider,
        this.settings.options.slider,
      );

      this.settings.instances.slider.slidePrev(0);
      this.settings.instances.slider.slideNext(0);
    }
  }

  customElements.define('slider-products', SliderProducts);
}
